var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgression(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 12.7767C13.5381 12.6785 13.7248 12.5462 13.8853 12.3853C14.6666 11.6047 14.6666 10.3473 14.6666 7.83333C14.6666 5.31933 14.6666 4.062 13.8853 3.28133C13.1039 2.50067 11.8473 2.5 9.33325 2.5H6.66658C4.15259 2.5 2.89525 2.5 2.11459 3.28133C1.33392 4.06267 1.33325 5.31933 1.33325 7.83333C1.33325 10.3473 1.33325 11.6047 2.11459 12.3853C2.27592 12.5473 2.45725 12.6753 2.66659 12.7767",
    stroke: "#23A26D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63315 11.2C7.25315 10.58 7.56382 10.2693 7.94648 10.2487C7.98204 10.2473 8.01737 10.2473 8.05248 10.2487C8.43515 10.2687 8.74582 10.5793 9.36648 11.2C10.7171 12.5507 11.3925 13.226 11.2031 13.8087C11.187 13.8586 11.1669 13.9072 11.1431 13.954C10.8645 14.5 9.90982 14.5 7.99982 14.5C6.08982 14.5 5.13448 14.5 4.85648 13.954C4.8327 13.9072 4.81264 13.8586 4.79648 13.8087C4.60715 13.226 5.28248 12.5507 6.63315 11.2Z",
    stroke: "#23A26D",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgression);
export default __webpack_public_path__ + "static/media/Progression.b0d8dba1e5af2e81803cdf2c5900815f.svg";
export { ForwardRef as ReactComponent };